import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {TranslationService} from "../../../../../core/services/translation.service";
import {
  AddressFormularField,
  AddressFieldHandler,
} from "./address-field-handler";

@Component({
  selector: 'app-hup-subscription-address-specifics',
  templateUrl: './hup-subscription-address-specifics.component.html',
  styleUrls: ['./hup-subscription-address-specifics.component.css']
})
export class HupSubscriptionAddressSpecificsComponent {
  @Input() controlGroup: FormGroup;
  @Input() streetNames: string[];
  @Input() isAustriaSelected: boolean;
  @Output() searchAddressEmit: EventEmitter<any> = new EventEmitter();
  @Input() addressFieldHandler?: AddressFieldHandler;

  constructor(public translationService: TranslationService) {
  }

  replaceInvalidCharactersFromHouseNo() {
    var value = this.controlGroup.get('address.houseNo').value.toUpperCase();
    if(value.length > 10) value = value.slice(0, 10);
    this.controlGroup.get('address.houseNo').setValue(value.replace(/[^A-Za-z0-9\-\/]*/g, ''), {emitEvent: false});
  }

  protected readonly document = typeof document === 'object' ? document : null;

  isRequired(fieldName: AddressFormularField) {
    return this.addressFieldHandler.isRequired(fieldName);
  }

  protected readonly AddressFormularField = AddressFormularField;
}
